import { render, staticRenderFns } from "./GetCode.vue?vue&type=template&id=4d225300&"
import script from "./GetCode.vue?vue&type=script&lang=js&"
export * from "./GetCode.vue?vue&type=script&lang=js&"
import style0 from "./GetCode.vue?vue&type=style&index=0&lang=css&"
import style1 from "./GetCode.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports